// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jdHCO","colBig":"styles_colBig__1_JrM","colSmall":"styles_colSmall__19Q2B"};